import { render, staticRenderFns } from "./ModalWarning.vue?vue&type=template&id=15c4aa09&scoped=true"
import script from "./ModalWarning.vue?vue&type=script&lang=js"
export * from "./ModalWarning.vue?vue&type=script&lang=js"
import style0 from "./ModalWarning.vue?vue&type=style&index=0&id=15c4aa09&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c4aa09",
  null
  
)

export default component.exports